export const PASSWORD_MIN = 8;
export const PASSWORD_MIN_ADMIN = 12;
export const PASSWORD_MAX = 150;
